var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaErfolgsgeschichteBwOnlineShopPhoneMockup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 373,
    viewBox: "0 0 191 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.202 126.1C189.202 126.1 190.002 125.3 190.002 124.3V80C190.002 79 189.202 78.2 188.202 78.2C187.202 78.2 186.402 79 186.402 80V124.4C186.402 125.3 187.202 126.1 188.202 126.1Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.202 147.7C189.202 147.7 190.002 146.9 190.002 145.9V135.1C190.002 134.1 189.202 133.3 188.202 133.3C187.202 133.3 186.402 134.1 186.402 135.1V145.9C186.402 146.9 187.202 147.7 188.202 147.7Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3008 372.1H35.6008H154.001H154.101C155.901 372.1 157.301 372 158.701 371.9C158.801 371.9 158.926 371.875 159.051 371.85C159.176 371.825 159.301 371.8 159.401 371.8C165.901 371.1 171.501 368.9 176.001 365.5C178.401 363.8 180.401 361.7 182.101 359.3L182.201 359.1L182.301 358.9C183 357.901 183.6 356.802 184.199 355.703L184.201 355.7C186.701 350.9 187.901 345.4 187.901 339.2V33.1C187.901 27.9 187.001 23.1 185.301 18.9L185.201 18.6L185.101 18.3C182.701 13.1 178.901 8.60002 174.101 5.40002L173.801 5.19995L173.501 5C169.401 2.5 164.701 1.00002 159.301 0.400024H159.101C157.801 0.300024 156.401 0.199951 154.901 0.199951H152.601H34.4006H34.2007C32.4019 0.199951 31.0026 0.299894 29.6036 0.39983L29.6008 0.400024C29.5008 0.400024 29.3758 0.425018 29.2507 0.450012C29.1257 0.475006 29.0006 0.5 28.9006 0.5C22.4006 1.3 16.8007 3.40002 12.2007 6.90002L12.0007 7L11.8008 7.09998C8.70078 9.59998 6.20068 12.6 4.20068 16.1L4.10083 16.3L4.00073 16.5C1.50073 21.3 0.300781 26.8 0.300781 33V339.3C0.300781 344.5 1.20063 349.3 2.90063 353.5C5.30063 359.4 9.30068 364.1 14.7007 367.3C18.8007 369.8 23.5006 371.3 28.9006 371.9H29.1008C30.4008 372 31.8008 372.1 33.3008 372.1ZM165.8 17.6C168.3 19.3 170.3 21.6 171.6 24.4C172.6 26.8 173.1 29.6 173.1 33V339.1C173.1 343 172.3 346.2 171 348.8C170.7 349.4 170.4 350 170 350.5V350.6C169.2 351.8 168.2 352.8 167.1 353.6C164.5 355.6 161.2 356.7 157.5 357.1H157.4H157.397C156.198 357.2 154.999 357.3 153.8 357.3H35.8H33.5C33 357.25 32.5 357.225 32 357.2C31.5 357.175 31 357.15 30.5 357.1C27.4 356.7 24.6 355.9 22.3 354.5C19.7 352.9 17.7 350.7 16.5 347.7C15.5 345.3 15 342.5 15 339.1V33C15 29.1 15.8001 25.9 17.1001 23.3C18.1001 21.4 19.5001 19.8 21.1001 18.5C23.7001 16.5 27 15.4 30.7 15H30.8C32 14.9 33.1999 14.8 34.3999 14.8H45.8H47.3H140.9H149.8H152.3H154.6C155.1 14.85 155.6 14.875 156.1 14.9C156.6 14.925 157.1 14.95 157.6 15C160.7 15.4 163.5 16.2 165.8 17.6Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7007 368.5H36.0007H153.501H153.601C155.301 368.5 156.601 368.4 157.901 368.3C158.101 368.2 158.301 368.2 158.501 368.2C164.401 367.5 169.401 365.6 173.501 362.5C175.601 361 177.401 359.1 178.901 357L179.001 356.8L179.101 356.6C179.701 355.7 180.301 354.8 180.801 353.8C183.001 349.5 184.101 344.5 184.101 338.8V33.4999C184.101 28.6999 183.301 24.2999 181.701 20.4999L181.601 20.2999L181.501 20.0999C179.301 15.3999 175.901 11.3999 171.601 8.49988L171.401 8.29993L171.201 8.19983C167.601 5.99983 163.301 4.69985 158.401 4.09985H158.201C157.001 3.99985 155.701 3.8999 154.301 3.8999H152.001H34.5007H34.3008C32.6008 3.8999 31.3007 3.99985 30.0007 4.09985C29.8008 4.19983 29.6007 4.19983 29.4008 4.19983H29.4006C23.5006 4.79983 18.4008 6.7999 14.3008 9.8999L14.2007 9.99988L14.1008 10.0999C11.3008 12.2999 9.00078 15.0998 7.30078 18.1998L7.20068 18.3999L7.10083 18.5999C4.90083 22.8999 3.80078 27.8999 3.80078 33.5999V338.9C3.80078 343.7 4.60068 348.1 6.20068 351.9C8.40068 357.2 11.9007 361.3 16.7007 364.2C20.4007 366.4 24.7008 367.7 29.6008 368.3H29.8008C31.0008 368.4 32.3007 368.5 33.7007 368.5ZM165.8 17.6C168.3 19.3 170.3 21.6 171.6 24.4C172.6 26.8 173.1 29.6 173.1 33V339.1C173.1 343 172.3 346.2 171 348.8C170.7 349.4 170.4 350 170 350.5V350.6C169.2 351.8 168.2 352.8 167.1 353.6C164.5 355.6 161.2 356.7 157.5 357.1H157.4H157.397C156.198 357.2 154.999 357.3 153.8 357.3H35.8H33.5C33 357.25 32.5 357.225 32 357.2C31.5 357.175 31 357.15 30.5 357.1C27.4 356.7 24.6 355.9 22.3 354.5C19.7 352.9 17.7 350.7 16.5 347.7C15.5 345.3 15 342.5 15 339.1V33C15 29.1 15.8001 25.9 17.1001 23.3C18.1001 21.4 19.5001 19.8 21.1001 18.5C23.7001 16.5 27 15.4 30.7 15H30.8C32 14.9 33.1999 14.8 34.3999 14.8H45.8H47.3H140.9H149.8H152.3H154.6C155.1 14.85 155.6 14.875 156.1 14.9C156.6 14.925 157.1 14.95 157.6 15C160.7 15.4 163.5 16.2 165.8 17.6Z",
    fill: "#131313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.799 21.7001L177.899 21.8002C179.199 25.0002 179.899 28.8001 179.799 33.0001V339.1C179.799 344 178.899 348.3 176.999 351.9C176.599 352.8 176.099 353.6 175.599 354.3L175.499 354.4L175.399 354.5C174.099 356.2 172.699 357.7 170.999 359C167.499 361.6 163.199 363.2 158.199 363.8H157.799C156.699 363.9 155.399 364 153.799 364H153.699H35.5994H33.2993C31.9993 364 30.8993 363.9 29.7993 363.8H29.6992C25.4992 363.3 21.8993 362.1 18.7993 360.3C14.8993 357.9 11.9992 354.6 10.1992 350.3C8.89922 347 8.19922 343.3 8.19922 339.1V33.0001C8.19922 28.1001 9.09927 23.8001 10.9993 20.2001L11.0994 20.1001L11.1992 20.0001C12.6992 17.4001 14.5992 15.2002 16.8992 13.3002L16.9993 13.2001L17.0994 13.1001C20.5994 10.5001 24.8992 8.90017 29.8992 8.30017H30.2993L30.3013 8.30001C31.5006 8.20006 32.7002 8.1001 34.2993 8.1001H34.3992H42.8992H47.4993H141.099H150.199H152.499H154.799C156.099 8.1001 157.198 8.20005 158.297 8.29998L158.299 8.30017H158.399C162.599 8.80017 166.199 10.0002 169.299 11.8002L169.399 11.9001L169.499 12.0001C173.099 14.4001 175.899 17.7001 177.699 21.6001L177.799 21.7001ZM165.8 17.6C168.3 19.3 170.3 21.6 171.6 24.4C172.6 26.8 173.1 29.6 173.1 33V339.1C173.1 343 172.3 346.2 171 348.8C170.7 349.4 170.4 350 170 350.5V350.6C169.2 351.8 168.2 352.8 167.1 353.6C164.5 355.6 161.2 356.7 157.5 357.1H157.4H157.397C156.198 357.2 154.999 357.3 153.8 357.3H35.8H33.5C33 357.25 32.5 357.225 32 357.2C31.5 357.175 31 357.15 30.5 357.1C27.4 356.7 24.6 355.9 22.3 354.5C19.7 352.9 17.7 350.7 16.5 347.7C15.5 345.3 15 342.5 15 339.1V33C15 29.1 15.8001 25.9 17.1001 23.3C18.1001 21.4 19.5001 19.8 21.1001 18.5C23.7001 16.5 27 15.4 30.7 15H30.8C32 14.9 33.1999 14.8 34.3999 14.8H45.8H47.3H140.9H149.8H152.3H154.6C155.1 14.85 155.6 14.875 156.1 14.9C156.6 14.925 157.1 14.95 157.6 15C160.7 15.4 163.5 16.2 165.8 17.6Z",
    fill: "#131313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1016 8.40002C26.3016 8.40002 26.5014 8.40005 26.7014 8.30005C28.0014 8.20005 29.4014 8.09998 31.2014 8.09998H31.3015H155.302H157.802C159.302 8.09998 160.602 8.20005 161.802 8.30005H161.901C166.901 8.80005 171.201 10.2 174.901 12.3L175.102 12.4L175.302 12.5C175.802 12.8 176.301 13.2 176.901 13.6C175.301 11.8 173.501 10.2 171.501 8.90002L171.302 8.80005L171.102 8.69995C167.602 6.59995 163.401 5.19995 158.701 4.69995H158.602C157.402 4.59995 156.201 4.5 154.701 4.5H152.401H34.2014H34.1016C32.4016 4.5 31.1015 4.59995 29.8015 4.69995C29.6015 4.69995 29.4014 4.70005 29.2014 4.80005C23.5014 5.50005 18.6014 7.30005 14.7014 10.3L14.6016 10.4L14.5015 10.5C13.3015 11.5 12.1016 12.6 11.1016 13.8C15.2016 10.8 20.3016 9.00002 26.1016 8.40002Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4014 365C15.9014 362.2 12.5015 358.2 10.5015 353.2C9.00146 349.5 8.20142 345.2 8.20142 340.5V31.6C8.20142 26.1 9.30137 21.2 11.4014 17L11.5015 16.8L11.6016 16.6C13.3016 13.6 15.4015 10.9 18.0015 8.69995L18.1016 8.59998L18.2014 8.5C19.2014 7.7 20.2015 7.1 21.3015 6.5C18.9015 7.4 16.7014 8.59998 14.7014 10.1L14.6016 10.2L14.5015 10.3C11.8015 12.5 9.60146 15.1 8.00146 18.1L7.90137 18.3L7.80151 18.5C5.70151 22.6 4.60156 27.5 4.60156 33V339.1C4.60156 343.8 5.40137 348 6.90137 351.7C9.00137 356.7 12.4014 360.7 16.9014 363.4C18.2014 364.2 19.7014 364.9 21.2014 365.5C21.0014 365.4 20.7014 365.2 20.4014 365Z",
    fill: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4014 365C15.9014 362.2 12.5015 358.2 10.5015 353.2C9.00146 349.5 8.20142 345.2 8.20142 340.5V31.6C8.20142 26.1 9.30137 21.2 11.4014 17L11.5015 16.8L11.6016 16.6C13.3016 13.6 15.4015 10.9 18.0015 8.69995L18.1016 8.59998L18.2014 8.5C19.2014 7.7 20.2015 7.1 21.3015 6.5C18.9015 7.4 16.7014 8.59998 14.7014 10.1L14.6016 10.2L14.5015 10.3C11.8015 12.5 9.60146 15.1 8.00146 18.1L7.90137 18.3L7.80151 18.5C5.70151 22.6 4.60156 27.5 4.60156 33V339.1C4.60156 343.8 5.40137 348 6.90137 351.7C9.00137 356.7 12.4014 360.7 16.9014 363.4C18.2014 364.2 19.7014 364.9 21.2014 365.5C21.0014 365.4 20.7014 365.2 20.4014 365Z",
    fill: "url(#paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.701 365C172.201 362.2 175.601 358.2 177.601 353.2C179.101 349.5 179.901 345.2 179.901 340.5V31.6C179.901 26.1 178.801 21.2 176.701 17L176.601 16.8L176.501 16.6C174.801 13.6 172.701 10.9 170.101 8.69995L170.001 8.59998L169.901 8.5C168.901 7.7 167.901 7.1 166.801 6.5C169.201 7.4 171.401 8.59998 173.401 10.1L173.501 10.2L173.601 10.3C176.301 12.5 178.501 15.1 180.101 18.1L180.201 18.3L180.301 18.5C182.401 22.6 183.501 27.5 183.501 33V339.1C183.501 343.8 182.701 348 181.201 351.7C179.101 356.7 175.701 360.7 171.201 363.4C169.901 364.2 168.401 364.9 166.901 365.5C167.201 365.3 167.401 365.2 167.701 365Z",
    fill: "url(#paint5_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M167.701 365C172.201 362.2 175.601 358.2 177.601 353.2C179.101 349.5 179.901 345.2 179.901 340.5V31.6C179.901 26.1 178.801 21.2 176.701 17L176.601 16.8L176.501 16.6C174.801 13.6 172.701 10.9 170.101 8.69995L170.001 8.59998L169.901 8.5C168.901 7.7 167.901 7.1 166.801 6.5C169.201 7.4 171.401 8.59998 173.401 10.1L173.501 10.2L173.601 10.3C176.301 12.5 178.501 15.1 180.101 18.1L180.201 18.3L180.301 18.5C182.401 22.6 183.501 27.5 183.501 33V339.1C183.501 343.8 182.701 348 181.201 351.7C179.101 356.7 175.701 360.7 171.201 363.4C169.901 364.2 168.401 364.9 166.901 365.5C167.201 365.3 167.401 365.2 167.701 365Z",
    fill: "url(#paint6_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4014 7.1001C15.9014 9.9001 12.5015 13.9001 10.5015 18.9001C9.00146 22.6001 8.20142 26.9001 8.20142 31.6001V340.5C8.20142 346 9.30137 350.9 11.4014 355.1L11.5015 355.3L11.6016 355.5C13.3016 358.5 15.4015 361.2 18.0015 363.4L18.1016 363.5L18.2014 363.6C19.2014 364.4 20.2015 365 21.3015 365.6C18.9015 364.7 16.7014 363.5 14.7014 362L14.6016 361.9L14.5015 361.8C11.8015 359.6 9.60146 357 8.00146 354L7.90137 353.8L7.80151 353.6C5.70151 349.5 4.60156 344.6 4.60156 339.1V33.0001C4.60156 28.3001 5.40137 24.1001 6.90137 20.4001C9.00137 15.4001 12.4014 11.4001 16.9014 8.70007C18.2014 7.90007 19.7014 7.2001 21.2014 6.6001C21.0014 6.7001 20.7014 6.9001 20.4014 7.1001Z",
    fill: "url(#paint7_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.701 7.1001C172.201 9.9001 175.601 13.9001 177.601 18.9001C179.101 22.6001 179.901 26.9001 179.901 31.6001V340.5C179.901 346 178.801 350.9 176.701 355.1L176.601 355.3L176.501 355.5C174.801 358.5 172.701 361.2 170.101 363.4L170.001 363.5L169.901 363.6C168.901 364.4 167.901 365 166.801 365.6C169.201 364.7 171.401 363.5 173.401 362L173.501 361.9L173.601 361.8C176.301 359.6 178.501 357 180.101 354L180.201 353.8L180.301 353.6C182.401 349.5 183.501 344.6 183.501 339.1V33.0001C183.501 28.3001 182.701 24.1001 181.201 20.4001C179.101 15.4001 175.701 11.4001 171.201 8.70007C169.901 7.90007 168.401 7.2001 166.901 6.6001C167.201 6.8001 167.401 6.9001 167.701 7.1001Z",
    fill: "url(#paint8_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8999 9.69995H103.2C104 9.69995 104.6 10.3 104.6 11.1V11.6C104.6 12.4 104 13 103.2 13H84.8999C84.0999 13 83.5 12.4 83.5 11.6V11.1C83.5 10.4 84.1999 9.69995 84.8999 9.69995Z",
    fill: "#212121"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.899 13.3H85.0994C84.0994 13.3 83.1992 12.5 83.1992 11.4C83.1992 10.4 83.9994 9.5 85.0994 9.5H102.899C103.899 9.5 104.799 10.3 104.799 11.4C104.799 12.4 103.999 13.3 102.899 13.3ZM85.1992 9.90002C84.3992 9.90002 83.6992 10.6 83.6992 11.4C83.6992 12.2 84.3992 12.9 85.1992 12.9H102.999C103.799 12.9 104.499 12.2 104.499 11.4C104.499 10.6 103.799 9.90002 102.999 9.90002H85.1992Z",
    fill: "url(#paint9_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M112 11.3999C112 9.9999 113.1 8.8999 114.5 8.8999C115.9 8.8999 117 9.9999 117 11.3999C117 12.7999 115.9 13.8999 114.5 13.8999C113.1 13.8999 112 12.7999 112 11.3999Z",
    fill: "url(#paint10_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M116.4 11.3999C116.4 12.4999 115.1 13.1998 114.8 12.9998C114.6 12.8998 114.8 12.4999 114.8 11.3999C114.8 10.1999 114.6 9.8999 114.8 9.7999C115.1 9.5999 116.4 10.3999 116.4 11.3999Z",
    fill: "url(#paint11_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M112.602 11.4C112.602 12.1 113.401 12.6999 113.701 12.5999C113.801 12.4999 113.701 12.3 113.701 11.4C113.701 10.6 113.801 10.2999 113.701 10.1999C113.401 10.0999 112.602 10.7 112.602 11.4Z",
    fill: "url(#paint12_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 190.142,
    y1: 102.152,
    x2: 187.93,
    y2: 102.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0861896,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3053,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4809,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5897,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#4C4C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 190.142,
    y1: 140.543,
    x2: 187.93,
    y2: 140.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0861896,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3053,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4809,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5897,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#4C4C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 94.0452,
    y1: 4.1824,
    x2: 94.0452,
    y2: 7.47922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1319,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3016,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9127,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 3.84236,
    y1: 186.062,
    x2: 8.60215,
    y2: 186.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1319,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3016,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9127,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -55.6155,
    y1: 150.044,
    x2: -51.7217,
    y2: 151.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1319,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3016,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9127,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 184.304,
    y1: 186.039,
    x2: 179.544,
    y2: 186.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1319,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3016,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9127,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 246.084,
    y1: 146.491,
    x2: 242.191,
    y2: 148.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1319,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3016,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9127,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -55.6155,
    y1: 222.058,
    x2: -51.7217,
    y2: 220.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1319,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3016,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9127,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 246.084,
    y1: 225.611,
    x2: 242.191,
    y2: 223.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1319,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3016,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6974,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9127,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 94.0677,
    y1: 13.278,
    x2: 94.0677,
    y2: 9.5667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9718,
    stopColor: "#131313"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.446 11.4223) scale(2.4641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9872
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.875 11.0877) scale(2.69507 2.69526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2936,
    stopColor: "#575376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#342C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8251,
    stopColor: "#1F1568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9718,
    stopColor: "#170C66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 113.704,
    y1: 11.4223,
    x2: 112.599,
    y2: 11.4223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9718,
    stopColor: "#292D95"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaErfolgsgeschichteBwOnlineShopPhoneMockup);
export default __webpack_public_path__ + "static/media/alkima-erfolgsgeschichte-bw-online-shop-phone-mockup.390c14bad39bd25d1752c20c2489a374.svg";
export { ForwardRef as ReactComponent };